/** Words on the free-trial pages (room for Urdu in Phase 2, CLAUDE.md "Copy"). */
export const TRIAL_DAYS = 15;

export const trialCopy = {
  pitch: {
    line: `Try Fitnatic free for ${TRIAL_DAYS} days.`,
    detail: 'Your own private gym, ready in a minute and already filled with sample members, trainers, plans and payments.',
    points: [
      `Free for ${TRIAL_DAYS} days. No card, no payment.`,
      'Private to you: nobody else sees your gym.',
      'Ready to use for real: remove the sample data in one click.',
    ],
    note: 'Fitnatic by WPCodie. The gym CRM and member app for Pakistan.',
  },
  form: {
    title: 'Start your free trial',
    subtitle: "We'll email you a link to choose your password.",
    name: 'Your name',
    namePlaceholder: 'Kamran Ali',
    nameRequired: 'Enter your name',
    email: 'Email',
    emailPlaceholder: 'kamran@ironpulse.pk',
    emailRequired: 'Enter your email address',
    emailInvalid: 'Enter a valid email address, like name@gym.pk',
    gym: "Your gym's name",
    gymPlaceholder: 'Iron Pulse Fitness',
    gymRequired: "Enter your gym's name",
    phone: 'Mobile or WhatsApp',
    phonePlaceholder: '0300 1234567',
    phoneHint: 'Optional. Only WPCodie uses it, to help you get started.',
    phoneInvalid: 'Enter a phone number, or leave it empty',
    website: 'Leave this empty',
    submit: `Start my ${TRIAL_DAYS}-day trial`,
    submitting: 'Setting up your gym',
    terms: 'Sample data only at first: please do not upload real member photos or receipts until you remove it.',
    signIn: 'Already have an account?',
    signInLink: 'Sign in',
    back: 'Back to Fitnatic',
  },
  banner: {
    label: 'Free trial',
    left: (days: number) => (days === 0 ? 'Your trial ends today' : `${days} day${days === 1 ? '' : 's'} left`),
    until: (date: string) => `(until ${date}).`,
    sample: 'The members, trainers and payments you see are sample data.',
    keep: 'Keep Fitnatic? Email',
    contact: 'service@wpcodie.com',
    remove: 'Remove sample data',
  },
  remove: {
    title: 'Remove the sample data?',
    body: 'The sample members and trainers go, with their payments, plans, logs and messages. Your timing slots, membership plans, payment accounts, workout and diet templates, video library and settings stay, and so does anything you added yourself.',
    irreversible: 'This cannot be undone.',
    confirm: 'Remove sample data',
    removing: 'Removing',
    cancel: 'Keep it for now',
    done: (members: number, trainers: number) =>
      `Sample data removed: ${members} member${members === 1 ? '' : 's'} and ${trainers} trainer${trainers === 1 ? '' : 's'}. Your gym is ready for real members.`,
  },
  sent: {
    title: 'Check your inbox',
    body: (email: string) =>
      `If ${email} can start a trial, an email from Fitnatic is on its way with a button to choose your password. Your gym is ready when you are.`,
    spam: 'Nothing after a few minutes? Look in spam or promotions, and search for "Fitnatic".',
    already: 'Started a trial before with this address? Sign in, or use "Forgot password?" on the sign-in page.',
    signIn: 'Go to sign in',
    again: 'Use a different email',
    resend: 'Send the email again',
    resendIn: (seconds: number) => `Send the email again (${seconds}s)`,
    resending: 'Sending',
    resent: 'Sent again. It can take a minute or two to arrive.',
    resendFailed: "We couldn't send it just now. Please try again in a few minutes.",
  },
} as const;
